import Axios from 'axios'

const _axios = Axios.create({
  baseURL: 'https://internal.doggiebobo.com',
  // baseURL: 'http://localhost:8080',
  withCredentials: true
})

export default _axios